import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'

import { ApiError } from '@/api/client'
import { BootScreen, Layout } from '@/components/Layout'
import { AuthProvider, useAuth } from '@/hooks/useAuth'
import { ConvertPage } from '@/pages/ConvertPage'
import { LoginPage } from '@/pages/LoginPage'
import { RulesPage } from '@/pages/RulesPage'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Une session expirée n'a aucune chance d'aboutir en réessayant :
      // mieux vaut ramener tout de suite l'utilisateur à l'écran de connexion.
      retry: (failureCount, error) =>
        !(error instanceof ApiError && error.status >= 400 && error.status < 500) && failureCount < 2,
      refetchOnWindowFocus: false,
    },
  },
})

function Shell() {
  const { user, loading } = useAuth()

  if (loading) return <BootScreen>Vérification de la session…</BootScreen>
  if (!user) return <LoginPage />

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<ConvertPage />} />
        <Route path="regles" element={<RulesPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Route>
    </Routes>
  )
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthProvider>
          <Shell />
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
